export default __webpack_public_path__ + "static/media/all-virtual-title.3ed5c4ed.png";